import { joiResolver } from '@hookform/resolvers/joi';
import { useForm, UseFormReturn } from 'react-hook-form';
import { SiblingFormData } from '../../../models';
import siblingSchema from '../schema/siblingSchema';

interface FormSiblingReturn {
  /**
   * Perform submit action, either to call block call or unblock call, depends on the account status
   */
  submitForm: (submitData: SiblingFormData) => void;
  /**
   * Form to send edit & delete
   */
  formHook: UseFormReturn<SiblingFormData>;
  /**
   * React query mutation object
   */
}

/**
 * A hook to handle search functionality
 * @returns
 */
export const useFormSibling = (defaultFormValues?: any): FormSiblingReturn => {
  const formHook = useForm<SiblingFormData>({
    mode: 'onSubmit',
    resolver: joiResolver(siblingSchema),
    defaultValues: defaultFormValues,
  });

  const submitForm = (submitData: SiblingFormData) => {
    // do nothing
  };

  return {
    formHook,
    submitForm,
  };
};
